export enum Features {
    ServiceProviders = 'ServiceProviders',
    OfflineWorkbook = 'OfflineWorkbook',
    PostJobAnalysis = 'PostJobAnalysis',
    NewCasingPlugs = 'NewCasingPlugs',
    JobSimulator = 'JobSimulator',
    CompanyAdministration = 'CompanyAdministration',
    UserProfileUi = 'UserProfileUi'
}
